import z from 'zod';

export const cdnUploadResultSchema = z.object({
  application: z.string().describe('The application name (e.g., "products")'),
  name: z.string().describe('The file name'),
  hashName: z.string().describe('The hash of the file'),
  path: z.string().describe('The path to the file in the CDN'),
  bucket: z.string().describe('The S3 bucket name'),
  url: z.url().describe('The full URL to access the file'),
  contentType: z.string().describe('The MIME type of the file'),
  originalSize: z.number().int().positive().optional().nullable().describe('The original file size in bytes'),
  compressedSize: z.number().int().nonnegative().optional().nullable().describe('The compressed file size in bytes'),
  compressionRatio: z.number().min(0).max(1).optional().nullable().describe('The compression ratio (0-1)'),
  compressionTime: z
    .number()
    .int()
    .nonnegative()
    .optional()
    .nullable()
    .describe('The time taken to compress in milliseconds'),
  metadata: z.record(z.string(), z.string()).optional().describe('Additional metadata about the file')
});

export type CdnUploadResult = z.infer<typeof cdnUploadResultSchema>;
